<template>
  <div>    
    <ADataTable
      :headers="headers"
      :api="api"
      :apiParams="apiParams"
      :sortBy="'endTimeFormatted'"
      :sortDesc="true"
      :hideTitleBar="true"
      :exportable="false"
      :btnAction="true"
      :shouldShowBtn="(item)=> {  return item.endTime != null}"
      btnText="Print BOL"
      @click:btn="printBOL"
      ref="table"
    ></ADataTable>
  </div>
</template>

<script>
import CartsLogMixin from "../../mixins/CartsLog";
import CRUDFuncsMixin from "../../mixins/CRUDFuncs";
import ASearchForm from "../../components/ASearchForm";
import CartsLog from "../../components/CartsLog";
import ADataTable from "../../components/ADataTable";
import logApi from "../../api/log";
import { time } from "../../utils";
import config from '../../../config'

export default {
  name: "ScanLog",
  mixins: [CartsLogMixin, CRUDFuncsMixin],
  components: {
    ASearchForm,
    ADataTable
  },
  data() {
    return {
      model: "account/sessions",
      headers: [
        { text: "Session ID", value: "id", sortable: false },
        {
          text: "Start Time",
          value: "startTimeFormatted",
          cusOrderByName: "startTime",
          sortable: false,
          format: {
            value: "startTime",
            formatter: v => {
              return time.format2(v);
            }
          }
        },
        {
          text: "End Time",
          value: "endTimeFormatted",
          cusOrderByName: "endTime",
          sortable: true,
          format: {
            value: "endTime",
            formatter: v => {
              if (v == null) return "Active Session";
              return time.format2(v);
            }
          }
        }
      ],
      apiParams: {}
    };
  },
  methods: {
    search(payload) {
      this.apiParams = payload;
    },
    printBOL(item) {
      console.log(item);
      window.open(config.axiosConfig.baseURL + "/account/sessions/" + item.id + "/bol", "_blank");
    }
  }
};
</script>



